import React from 'react';

import { toast } from 'react-toastify';

import { Bloc } from '@mairistem/administres-utils';
import { Icon, Image } from '@mairistem/composants';

import { BlocTile } from '@/components/Common';
import COLORS from '@/constants/colors';
import { useEntiteStore } from '@/zustand';
import { request } from '@mairistem/tools';
import InseeHistoriqueModal from '../Modals/InseeHistoriqueModal';
import InseeTransfertModal from '../Modals/InseeTransfertModal';
// @ts-expect-error
import insee from '../../../assets/images/insee.png';

interface BlocInseeProps {
  style?: React.CSSProperties;
  setLoading: (loading: boolean) => void;
}

const BlocInsee = (props: BlocInseeProps) => {
  const { style, setLoading } = props;
  const [statsInsee, setStatsInsee] = React.useState<any>(null);
  const [modalOuverte, setModalOuverte] = React.useState(false);
  const [historiqueOuvert, setHistoriqueOuvert] = React.useState(false);
  const blocked = useEntiteStore((state) => state.blocked);

  const chargerStats = React.useCallback(() => {
    setLoading(true);
    request
      .get('/api/administres/etat-civil/pacs/insee')
      .then((data) => {
        setStatsInsee(data.total);
      })
      .catch(() => {
        toast.error(
          'Une erreur est survenue lors de la récupération des données INSEE',
        );
      })
      .finally(() => setLoading(false));
  }, [setLoading]);

  React.useEffect(() => {
    if (!blocked) {
      chargerStats();
    }
  }, [blocked, chargerStats]);

  return (
    <Bloc
      header={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
            <Image src={insee} style={{ height: 'auto', maxWidth: '30px' }} />
            <span>Transfert INSEE</span>
            {/* Comme le rafraîchissement du bloc HubEE : icône seule */}
            <Icon
              name="history"
              title="Historique des transferts INSEE"
              disabled={blocked}
              onClick={blocked ? undefined : () => setHistoriqueOuvert(true)}
              style={{ marginLeft: '10px', cursor: 'pointer' }}
              data-testid="bloc-insee-historique"
            />
          </div>
        </div>
      }
      style={style}
    >
      <div style={{ marginTop: '1em' }}>
        <BlocTile
          title="PACS en attente"
          // Aucun PACS en attente : tuile non cliquable
          onClick={statsInsee > 0 ? () => setModalOuverte(true) : undefined}
          statsColor={COLORS.LightBlueCardColor}
          stats={statsInsee}
          style={{ margin: '30px' }}
        />
      </div>
      <InseeTransfertModal
        open={modalOuverte}
        onClose={() => setModalOuverte(false)}
        onTransfert={chargerStats}
      />
      <InseeHistoriqueModal
        open={historiqueOuvert}
        onClose={() => setHistoriqueOuvert(false)}
        onChange={chargerStats}
      />
    </Bloc>
  );
};

export default BlocInsee;
